import request from '@/utils/request'
const BASE_URL = '/PoContent'

//公告管理
export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  delete(data) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data
    })
  },
  uploadPicture(data) {
      return request({
          url: BASE_URL + '/UploadPicture',
          method: 'post',
          headers: { "Content-Type": "multipart/form-data" },
          data
      })
  },
  uploadMP4(data) {
      return request({
          url: BASE_URL + '/UploadMP4',
          method: 'post',
          headers: { "Content-Type": "multipart/form-data" },
          data
      })
  },
}